
import { INotice, NoticePriority } from '@/store/notice-store';
import { Component, Vue } from "vue-property-decorator";
import NoticePassengers from '@/components/Notices/NoticePassengers.vue';
import NoticeTitle from '@/components/Notices/NoticeTitle.vue';
import { RawLocation } from 'vue-router';

@Component({
  components: {
    NoticePassengers,
    NoticeTitle,
  },
})
export default class Notice extends Vue {

  private loading = false;
  private statusMessage = '';
  
  get notice(): INotice | null {
    const id = this.$route.params.id;
    return this.$store.getters['notice/noticeById'](id) ?? null;
  }

  get noticeState() {
    if (!this.notice) {
      return null;
    }
    return this.$store.getters['notice/noticeUserStateByNoticeId'](this.notice.id) ?? null;
  }

  get titleId() {
    if (!this.notice) {
      return '';
    }
    return `notice-title-${this.notice.id}`;
  }

  get textId() {
    if (!this.notice) {
      return '';
    }
    return `notice-text-${this.notice.id}`;
  }

  get targetPassengersLabel() {
    return `${this.$t('notices.notice')}: ${this.$t('menu.passengers')}`;
  }

  get backButtonAriaLabel() {
    return `${this.$t('general.button.back')}: ${this.$t('menu.notices')}`;
  }

  get validityPeriod() {
    let start = null;
    let end = null;
    if (this.notice?.validFrom) {
      start = this.$options.filters?.date(this.notice.validFrom);
    }
    if (this.notice?.validUntil) {
      end = this.$options.filters?.date(this.notice.validUntil);
    }

    return [start, end].filter(Boolean).join(' - ');
  }

  get isSticky() {
    return this.notice?.priority === NoticePriority.Sticky;
  }

  get backLocation() {
    const route: RawLocation = { name: 'notices' };

    if (this.$route.query.passengerId) {
      route.query = { passengerId: this.$route.query.passengerId };
    }

    return route;
  }

  get showActions() {
    if (this.isSticky) {
      return false;
    }

    return !this.noticeState?.readAt;
  }

  async markNoticeAsRead() {
    if (!this.notice) {
      return;
    }
    this.loading = true;

    await this.$store.dispatch('notice/markNoticeAsRead', this.notice.id);
    this.statusMessage = this.$t('notices.marked-as-read').toString();
    this.loading = false;
  }

}
